// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-module--wrapper--2xuBH","fullWidth":"wrapper-module--fullWidth--NZNVo"};